// Números em pt-BR (DESIGN §6): milhar com ponto ("2.480"), decimal com vírgula ("42,5 kg"),
// pontos com sinal tipográfico ("+10 pts", "−5 pts").

const inteiro = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 });
const umaCasa = new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 1 });
const MENOS = "−"; // sinal de menos tipográfico

/** "2.480" */
export function formatarNumero(n: number): string {
  return inteiro.format(n).replace("-", MENOS);
}

/** "+10 pts" · "−5 pts" · "0 pts". `semSinal` para totais ("2.480 pts"). */
export function formatarPontos(n: number, opcoes: { semSinal?: boolean; unidade?: boolean } = {}): string {
  const unidade = opcoes.unidade === false ? "" : " pts";
  if (opcoes.semSinal || n === 0) return `${formatarNumero(n)}${unidade}`;
  return `${n > 0 ? "+" : MENOS}${inteiro.format(Math.abs(n))}${unidade}`;
}

/** "42,5 kg" (ou só "42,5" sem unidade). */
export function formatarKg(n: number, comUnidade = true): string {
  return comUnidade ? `${umaCasa.format(n)} kg` : umaCasa.format(n);
}

/** Segundos -> "0:42", "12:05", "1:02:03". */
export function formatarDuracao(totalSeg: number): string {
  const s = Math.max(0, Math.floor(totalSeg));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const seg = String(s % 60).padStart(2, "0");
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${seg}` : `${m}:${seg}`;
}

/** Duração legível: "41 min", "1 h 05 min". */
export function formatarDuracaoLonga(totalSeg: number): string {
  const min = Math.round(totalSeg / 60);
  if (min < 60) return `${min} min`;
  return `${Math.floor(min / 60)} h ${String(min % 60).padStart(2, "0")} min`;
}

/** 0.64 -> "64%" */
export function formatarPercentual(fracao: number, casas = 0): string {
  return new Intl.NumberFormat("pt-BR", { style: "percent", maximumFractionDigits: casas }).format(fracao);
}

/** 12 -> "12º" */
export function ordinal(n: number): string {
  return `${n}º`;
}

/** plural(1, "treino") -> "1 treino"; plural(3, "treino") -> "3 treinos"; plural irregular via 3º argumento. */
export function plural(n: number, singular: string, pluralForma = `${singular}s`): string {
  return `${formatarNumero(n)} ${Math.abs(n) === 1 ? singular : pluralForma}`;
}

/** Contagem de badge: até 9, depois "9+". */
export function contagemBadge(n: number, max = 9): string {
  return n > max ? `${max}+` : String(n);
}

/** Converte kg digitado ("42,5") em número com 1 casa, ou null se inválido. */
export function lerKg(texto: string): number | null {
  const n = Number(texto.replace(/\./g, "").replace(",", "."));
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 10) / 10;
}
